import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IAddAdminRequest } from '../models/add-admin.model';
import { fromAddAdminActions } from '../actions';

export const addAdminFeatureKey = 'addAdmin';

export interface AddAdminState {
  loadNewAdmin: IAddAdminRequest;
  loadNewAdminResponse: string;
  loadNewAdminFailure: IGenericError<ErrorResponse>;
}

export const initialState: AddAdminState = {
  loadNewAdmin: undefined,
  loadNewAdminFailure: undefined,
  loadNewAdminResponse: undefined
};

export const reducer = createReducer(
  initialState,
  on(fromAddAdminActions.loadAddAdmins, (state, action) => ({
    ...state,
    loadNewAdmin: action.request
  })),
  on(fromAddAdminActions.loadAddAdminsSuccess, (state, action) => ({
    ...state,
    loadNewAdminResponse: action.response
  })),
  on(fromAddAdminActions.loadAddAdminsFailure, (state, action) => ({
    ...state,
    loadNewAdminFailure: action.error
  }))
);
